import { sbMsgBus } from "../../mbus";
/* istanbul ignore next */
export const GeneralTopics = {
    SB_PlaceBetTopic: sbMsgBus.sbPrefix + "place_bet_topic",
    SB_CashoutTopic: sbMsgBus.sbPrefix + "cashout_topic"
}
